import { useState, useEffect, useCallback } from 'react';
import { PriceProduct, PriceListResponse } from '../types/costwand.d';
import { apiClient } from '../api/apiClient.tsx';

const DEFAULT_PAGE_SIZE = 20;

export const usePrices = (initialPage = 1) => {
  const [prices, setPrices] = useState<PriceProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);

  const fetchPrices = useCallback(async (page: number, pageSize: number = DEFAULT_PAGE_SIZE) => { // Made page a required argument
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient<PriceListResponse>(`/prices?page=${page}&page_size=${pageSize}`, { bypassCache: true }); // ADDED: Bypass cache for pagination
      setPrices(response.data);
      // REMOVED: setCurrentPage(response.pagination.page);
      setTotalPages(response.pagination.total_pages);
      setTotalItems(response.pagination.total_items);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch prices.');
      setPrices([]); // Clear data on error
      setTotalPages(1);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, []); // Removed currentPage from dependencies

  useEffect(() => {
    fetchPrices(currentPage); // Call with the current state value
  }, [fetchPrices, currentPage]); // Fetch on mount and when fetchPrices changes

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return {
    prices,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    fetchPrices, // Expose fetchPrices for manual refetching if needed
  };
};